<template>
  <WhitePage class="d-flex justify-content-center mb-3">
    <b-spinner class="m-5" label="Spinning"></b-spinner>
  </WhitePage>
</template>

<script>
import WhitePage from '@/components/WhitePage'
export default {
  components: {
    WhitePage
  },
  methods: {
    fetchFirst () {
      let account
      if(this.$route.params.no === 'test'){
        account = this.$store.getters.test
      }else{
        account = this.$store.getters.account(this.$route.params.no)
      }
      let token = account.token
      let eno = account.eno
      this.$store.dispatch('change', { token, eno })
        .then((response) => {
          if(response.error === '200 OK'){
            this.$store.commit('LOGIN')
            if(this.$route.params.no === 'test'){
              this.$store.commit('SET_ACCOUNTS', response.accounts)
              this.$store.commit('TEST_MODE', null)
            }else{
              this.$store.commit('UPDATE_ACCOUNTS', response.accounts)
              this.$store.dispatch('changeLoginIndex', this.$route.params.no)
            }
            this.$router.push({ path: account.to || '/result' })
          }else{
            this.$router.go(-1)
          }
        })
    }
  },
  mounted () {
    this.fetchFirst()
  }
}
</script>
